import { Star } from "lucide-react";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-[120px] pb-24 md:pt-[150px] md:pb-32 overflow-hidden">
      <div className="orb-gold w-[520px] h-[520px] left-[-140px] top-[80px]" />
      <div className="orb-gold w-[420px] h-[420px] right-[-120px] top-[300px] opacity-70" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center relative">
        <div className="relative z-10">
          <div className="rise inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/5 text-[#E8C87A] text-xs uppercase tracking-[0.25em]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E8C87A]" />
            Transporte turístico por toda Colombia
          </div>

          <h1 className="rise rise-1 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.98] mt-6 text-[#F5EFE0]">
            Alquiler de
            <span className="block text-gold-grad italic">vans, busetas y buses</span>
            en Bogotá.
          </h1>

          <p className="rise rise-2 mt-6 text-[#F5EFE0]/75 text-lg max-w-lg leading-relaxed">
            Vans, busetas y buses para grupos desde 5 pasajeros. Aeropuertos, city tours, rutas fuera de Bogotá y disponibilidad por horas — con conductores expertos y atención personalizada.
          </p>

          <div className="rise rise-3 mt-8 flex flex-wrap gap-3">
            <Link to="/cotizar" data-testid="hero-cta-quote" className="btn-gold px-7 py-3.5 rounded-full text-[15px]">
              Cotizar mi viaje
            </Link>
            <Link to="/nosotros" data-testid="hero-cta-fleet" className="btn-ghost-gold px-7 py-3.5 rounded-full text-[15px]">
              Conocer más
            </Link>
          </div>

          <div className="rise rise-4 mt-10 flex items-center gap-6">
            <div className="flex items-center gap-1">
              {[0,1,2,3,4].map((i) => <Star key={i} size={16} className="star-on fill-current" />)}
            </div>
            <div className="text-sm text-[#F5EFE0]/70">
              <span className="text-[#F5EFE0] font-semibold">+15 años</span> moviendo grupos por Colombia
            </div>
          </div>
        </div>

        <div className="relative rise rise-2 z-10 flex items-center justify-center">
          <div className="relative w-full max-w-[520px]">
            <img
              src="/mapa-hero.webp"
              alt="Mapa de Colombia — Líneas Doradas cubre todo el país"
              data-testid="hero-map"
              className="w-full h-auto drop-shadow-[0_0_50px_rgba(212,175,55,0.4)]"
            />
            {[
              { name: "Bogotá", x: 52, y: 62, main: true },
              { name: "Medellín", x: 40, y: 47 },
              { name: "Cartagena", x: 33, y: 20 },
              { name: "Villa de Leyva", x: 50, y: 55 },
              { name: "Cali", x: 33, y: 68 },
              { name: "Bucaramanga", x: 55, y: 41 },
              { name: "Santa Marta", x: 48, y: 12 },
              { name: "Guatavita", x: 54, y: 58 },
            ].map((c) => (
              <div key={c.name}
                   className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center gap-1"
                   style={{ left: `${c.x}%`, top: `${c.y}%` }}>
                <span className={`pulse-dot rounded-full ${c.main ? "w-3 h-3 bg-[#E8C87A]" : "w-2 h-2 bg-[#D4AF37]"}`}
                      style={{ boxShadow: c.main ? "0 0 20px 4px rgba(232,200,122,0.85)" : "0 0 12px 2px rgba(212,175,55,0.7)" }} />
                <span className={`text-[10px] font-medium tracking-wider uppercase pl-1 whitespace-nowrap ${c.main ? "text-[#0A0908]" : "text-[#0A0908]/70"}`}
                      style={{ textShadow: "0 1px 2px rgba(255,255,255,0.4)" }}>
                  {c.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="divider-gold mt-16 max-w-6xl mx-auto" />
    </section>
  );
}
